import React, { forwardRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { ErrorMessage, Field, Form, Formik } from 'formik'
import Box from '@mui/system/Box'
import Typography from '@mui/material/Typography'
import AdxDropdownWithAddButton from 'components/reusable/dropdownWithAddButton'
import AdxMenuItem from 'components/custom/AdxMenuItem'
import AdxInput from 'components/custom/AdxInput'
import CircularProgress from '@mui/material/CircularProgress'
import AdxErrorMessage from 'components/custom/AdxErrorMessage'
import { getQueryReports } from 'services/api/modules/claim/report'

const SelectClaimReport = forwardRef((props, ref) => {
  // react router
  const navigate = useNavigate()
  const location = useLocation()
  const pathname = location.pathname
  const { setNewClaimReport, setSelectedClaimReport, selectedCategory } = props
  const [ClaimReportOptions, setClaimReportOptions] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const handleCreateNewReport = (boolean) => {
    setNewClaimReport(boolean)
    setSelectedClaimReport(boolean)
  }

  // list all report from api
  const listAllReport = async () => {
    try {
      setIsLoading(true)
      const allReports = await getQueryReports({ status: 'draft' })
      setClaimReportOptions(allReports.data.reports)
    } catch (e) {
      console.log(e)
    } finally {
      setIsLoading(false)
    }
  }

  const handleCallReportList = () => {
    listAllReport()
  }

  const handleOptionsChange = (e) => {
    if (e.target.value?.title) {
      ref.current.setFieldValue('claimReport', e.target.value)
      ref.current.setFieldValue('title', e.target.value.title)
      ref.current.setFieldValue('type', e.target.value.claim_report_type)
      ref.current.setFieldValue('purpose', e.target.value.description)
      ref.current.setFieldValue('start_date', e.target.value.start_date)
      ref.current.setFieldValue('end_date', e.target.value.end_date)
      return
    }
  }

  return (
    <Formik
      innerRef={ref}
      enableReinitialize
      initialValues={{
        claimReport: '',
      }}
      onSubmit={(values) => {
        if (pathname === '/app/claim') {
          navigate(`../claim/reports/${values.claimReport.id}`, {
            state: {
              fromActionButton: true,
              selectedCategory: selectedCategory,
            },
          })
        } else {
          navigate(`../${values.claimReport.id}`, {
            state: { fromActionButton: true },
          })
        }
      }}
    >
      {({ values, handleChange, handleBlur, setFieldValue }) => {
        values.claimReport ? setSelectedClaimReport(true) : setSelectedClaimReport(false)

        return (
          <Form>
            <Box display="flex" flexDirection="column" rowGap={2}>
              <Box
                width={1}
                display="flex"
                flexDirection={{ xs: 'column', lg: 'row' }}
                alignItems="center"
                justifyContent="space-between"
                columnGap={{ xs: 0, lg: 3 }}
                rowGap={{ xs: 3, lg: 0 }}
              >
                <Field
                  name="title"
                  as={AdxDropdownWithAddButton}
                  sx={{ width: { xs: 1, lg: 2 / 3 } }}
                  sxButton={{ display: isLoading ? 'none' : null }}
                  onFocus={handleCallReportList}
                  onChange={handleOptionsChange}
                  onBlur={handleBlur}
                  options={ClaimReportOptions}
                  addNewOnClick={() => handleCreateNewReport(true)}
                  label="Claim report"
                  addNewText="Create new report"
                  renderValue={(option) => (
                    <Box>
                      <Typography variant="body1" color="dark-text">
                        {option.title}
                      </Typography>
                    </Box>
                  )}
                >
                  {isLoading ? (
                    <Box height={100} display="flex" justifyContent="center" alignItems="center">
                      <CircularProgress color="alternate" />
                    </Box>
                  ) : (
                    ClaimReportOptions.map((item, index) => (
                      <AdxMenuItem selectedvalue={values.claimReport} key={index} value={item}>
                        {item.title}
                      </AdxMenuItem>
                    ))
                  )}
                </Field>

                <Field
                  name="type"
                  as={AdxInput}
                  sx={{ width: { xs: 1, lg: 1 / 3 } }}
                  label="Type"
                  disabled
                />
              </Box>
              <Box>
                <Field
                  name="purpose"
                  as={AdxInput}
                  multiline
                  minRows={2}
                  sxInput={{ padding: 2 }}
                  sx={{ width: 1 }}
                  label="Purpose"
                  disabled
                />
              </Box>
              <Box
                width={1}
                display="flex"
                flexDirection={{ xs: 'column', lg: 'row' }}
                alignItems="center"
                justifyContent="space-between"
                columnGap={{ xs: 0, lg: 3 }}
                rowGap={{ xs: 3, lg: 0 }}
              >
                <Field
                  name="start_date"
                  as={AdxInput}
                  sx={{ width: { xs: 1, lg: 1 / 2 } }}
                  label="Start date"
                  disabled
                />
                <Field
                  name="end_date"
                  as={AdxInput}
                  sx={{ width: { xs: 1, lg: 1 / 2 } }}
                  label="End date"
                  disabled
                />
              </Box>
            </Box>
            <AdxErrorMessage errorMessage={<ErrorMessage name="claimReport" />} />
            <button type="submit" hidden>
              Submit
            </button>
          </Form>
        )
      }}
    </Formik>
  )
})

export default SelectClaimReport
